import { connect } from 'react-redux';
import BriefHead from 'project/components/brief/head';
import { getRankedTips } from 'project/ducks/entries';
import { getAwards } from 'entries/ducks';
import { toggleStatsModal } from 'project/ducks/project';

const mapStateToProps = (state) => {
  const awards = getAwards(state, false);
  const rankedTips = getRankedTips(state);

  return {
    awards,
    rankedTips
  };
};

export default connect(mapStateToProps, {
  toggleStatsModal
})(BriefHead);



// WEBPACK FOOTER //
// ./project/containers/brief_head.js